export const eliteAccionesRoles = {
  sideNavActions: {
    root: [
      'Admin',
      'PowerBiViewer',
      'PowerBiWsEliteAdmin',
      'PowerBiQualityControl',
      'PowerBiInspections',
    ],
    extraHours: ['Admin', 'PowerBiViewer', 'PowerBiWsEliteAdmin'],
    qualityControl: ['Admin', 'PowerBiViewer', 'PowerBiWsEliteAdmin'],
  },
};
